
import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { displayName, LeaderSummary, ReportFilters, Subgroup } from "./shared";

@Component
export default class FilterBar extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true }) readonly leaders!: LeaderSummary[];
  @Prop({ required: true }) readonly subgroups!: Subgroup[];
  @Prop({ required: true }) readonly filters!: ReportFilters;
  @Prop({ default: false }) readonly showHideNames!: boolean;

  get leaderLabel(): string {
    const active = this.filters.activeLeaderIds.filter((id) => this.leaders.some((l) => l.id === id)).length;
    const total = this.leaders.length;
    if (active === total) return this.$t("Filter::AllLeaders").toString();
    if (active === 0) return this.$t("Filter::NoLeaders").toString();
    return this.$t("Filter::SomeLeaders", { n: active, total }).toString();
  }

  get subgroupLabel(): string {
    const active = this.filters.activeSubgroupIds.length;
    const total = this.subgroups.length;
    if (active === total) return this.$t("Filter::AllSubgroups").toString();
    if (active === 0) return this.$t("Filter::NoSubgroups").toString();
    return this.$t("Filter::SomeSubgroups", { n: active, total }).toString();
  }

  leaderName(leader: LeaderSummary): string {
    return displayName(leader, this.filters.hideNames);
  }

  update(patch: Partial<ReportFilters>): void {
    this.$emit("update-filters", patch);
  }

  toggleLeader(id: string): void {
    const ids = this.filters.activeLeaderIds.includes(id) ? this.filters.activeLeaderIds.filter((x) => x !== id) : [...this.filters.activeLeaderIds, id];
    this.update({ activeLeaderIds: ids });
  }

  toggleSubgroup(id: string): void {
    const ids = this.filters.activeSubgroupIds.includes(id) ? this.filters.activeSubgroupIds.filter((x) => x !== id) : [...this.filters.activeSubgroupIds, id];
    this.update({ activeSubgroupIds: ids });
  }
}
